'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _propTypes = require('../../shared/prop-types');

var _loggingUtil = require('../../utils/logging-util');

var _actionCreators = require('../../store/actions/action-creators');

var _miniProfileDisplay = require('./mini-profile-display');

var _miniProfileDisplay2 = _interopRequireDefault(_miniProfileDisplay);

var _FeedItem = require('../FeedItem');

var _FeedItem2 = _interopRequireDefault(_FeedItem);

var _Uniform = require('../Uniform');

var _logValues = require('../../shared/logging/log-values');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConnectedMiniProfile = function (_PureComponent) {
  _inherits(ConnectedMiniProfile, _PureComponent);

  function ConnectedMiniProfile(props) {
    _classCallCheck(this, ConnectedMiniProfile);

    var _this = _possibleConstructorReturn(this, (ConnectedMiniProfile.__proto__ || Object.getPrototypeOf(ConnectedMiniProfile)).call(this, props));

    _this.defaultLogData = _defineProperty({
      app: _logValues.WEB_APP
    }, _logValues.ORIGIN_KEY, _logValues.MINI_PROFILE_ORIGIN);
    _this.state = {
      logData: _this.createLogData({}, props)
    };
    return _this;
  }

  _createClass(ConnectedMiniProfile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          feedUserId = _props.feedUserId,
          feedUser = _props.feedUser,
          feedItems = _props.feedItems;

      if (!feedUser || !feedItems || !feedItems.length) {
        this.props.fetchMiniProfileIfNeeded(feedUserId.type, feedUserId.relatedId);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var feedUserId = this.props.feedUserId;

      if (feedUserId && (nextProps.feedUserId.type !== feedUserId.type || nextProps.feedUserId.relatedId !== feedUserId.relatedId)) {
        this.props.fetchMiniProfileIfNeeded(nextProps.feedUserId.type, nextProps.feedUserId.relatedId);
      }

      this.setState({
        logData: this.createLogData(this.state.logData, nextProps)
      });
    }
  }, {
    key: 'createLogData',
    value: function createLogData(currentLogData, newProps) {
      var currentTeamId = newProps.currentTeamId,
          currentUserId = newProps.currentUserId;

      if (currentTeamId) {
        this.defaultLogData.currentTeamId = currentTeamId;
      }
      if (currentUserId) {
        this.defaultLogData.currentUserId = currentUserId;
      }

      return (0, _loggingUtil.copyLogData)(currentLogData, newProps.logData, this.defaultLogData);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (this.props.isFetching) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'feed-modal-close', onClick: this.props.onDialogClose },
            _react2.default.createElement(_Uniform.Icon, { type: 'uidismiss', size: 'large', color: 'subtle' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'infinite-css-spinner-wrapper full-height' },
            _react2.default.createElement(_Uniform.Spinner, { size: 'medium' })
          )
        );
      }

      var store = this.props.store;
      var feedItemsArray = this.props.feedItems || [];
      var feedItems = feedItemsArray.map(function (f) {
        return _react2.default.createElement(_FeedItem2.default, { key: f,
          feedContentId: f,
          store: store,
          hideFollowButton: true,
          profileLinkEnabled: true,
          showingMiniProfile: true,
          logData: _this2.state.logData
        });
      });
      if (!this.props.feedUser || !this.props.feedUser.feedUserId) return _react2.default.createElement('div', null);
      return _react2.default.createElement(
        _miniProfileDisplay2.default,
        {
          currentUserId: this.props.currentUserId,
          feedUser: this.props.feedUser,
          onDialogClose: this.props.onDialogClose,
          logData: this.state.logData
        },
        feedItems
      );
    }
  }]);

  return ConnectedMiniProfile;
}(_react.PureComponent);

ConnectedMiniProfile.propTypes = {
  currentTeamId: _react.PropTypes.string,
  currentUserId: _react.PropTypes.string,
  feedUserId: _propTypes.FeedUserId,
  feedUser: _propTypes.MiniProfileFeedUser,
  isFetching: _react.PropTypes.bool,
  fetchMiniProfileIfNeeded: _react.PropTypes.func.isRequired,
  onDialogClose: _react.PropTypes.func,
  logData: _react.PropTypes.object,
  feedItems: _react.PropTypes.arrayOf(_react.PropTypes.string),
  store: _react.PropTypes.object.isRequired
};
ConnectedMiniProfile.defaultProps = {
  onDialogClose: function onDialogClose() {}
};


function mapStateToProps(state, ownProps) {
  var feedUserKey = ownProps.feedUserId.type + '-' + ownProps.feedUserId.relatedId;

  var feedUser = void 0;
  if (state && state.miniProfile && state.miniProfile.feedUsers) {
    feedUser = state.miniProfile.feedUsers[feedUserKey];
  }

  var isFetching = void 0;
  var feedItems = [];
  if (state && state.userTimeline && state.userTimeline[feedUserKey]) {
    var userTimeline = state.userTimeline[feedUserKey];
    feedItems = userTimeline.feedItems;
    isFetching = userTimeline.isFetching;
  }

  return {
    currentTeamId: state.userDetails.teamId,
    currentUserId: state.userDetails.userId,
    feedItems: feedItems,
    feedUser: feedUser,
    isFetching: isFetching
  };
}

var mapDispatchToProps = {
  fetchMiniProfileIfNeeded: _actionCreators.fetchMiniProfileIfNeeded
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConnectedMiniProfile);